module.exports = __webpack_public_path__ + "static/wordpress-9d3591f7f82a82cf0b899bbe1230c3c5.jpg";